"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BeforeLogin;
var _react = _interopRequireWildcard(require("react"));
var _awsAmplify = require("aws-amplify");
var _reactBootstrap = require("react-bootstrap");
var _reactRouterDom = require("react-router-dom");
var _RoutePath = require("../RoutePath");
var _reactRedux = require("react-redux");
var _loginReducer = require("../common_features/redux/reducers/loginReducer");
var _helper = require("../common_features/utility/helper");
var _Services = require("../common_features/utility/Services");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function BeforeLogin(props) {
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const getCurrentRole = user => {
    var _user$attributes, _user$attributes2;
    (0, _Services.getRoles)().then(res => {
      if (res.success) {
        dispatch((0, _loginReducer.SetUserRoles)(res.data));
      }
    });
    let userType = user.signInUserSession.accessToken.payload["cognito:groups"][0];
    let roleId = (0, _helper.getUserTypeFromGroup)(userType);
    console.log('role id:-', user);
    let orgID = null;
    let serachUserType = null;
    switch (roleId) {
      case 4:
      case 6:
        orgID = user === null || user === void 0 ? void 0 : (_user$attributes = user.attributes) === null || _user$attributes === void 0 ? void 0 : _user$attributes['custom:organization_id'];
        serachUserType = 6;
        break;
      case 5:
      case 7:
        orgID = user === null || user === void 0 ? void 0 : (_user$attributes2 = user.attributes) === null || _user$attributes2 === void 0 ? void 0 : _user$attributes2['custom:sp_id'];
        serachUserType = 7;
        break;
    }
    dispatch((0, _loginReducer.loginUserInfo)({
      email: user.attributes.email,
      challengeName: user.challengeName,
      poolId: user.pool.userPoolId,
      username: user.username,
      userType: roleId,
      orgID,
      serachUserType
    }));
  };
  (0, _react.useEffect)(() => {
    _awsAmplify.Auth.currentAuthenticatedUser().then(user => {
      _awsAmplify.Auth.currentUserInfo().then(userAttr => {
        setIsLoading(false);
        if (userAttr.challengeName !== 'NEW_PASSWORD_REQUIRED' && user.ChallengeName !== 'PASSWORD_VERIFIER') {
          getCurrentRole(user);
        }
        if (userAttr.challengeName === 'NEW_PASSWORD_REQUIRED') {
          navigate(_RoutePath.baseRoutes.forceChangePassword.useLink);
        } else if (+userAttr.attributes["custom:onboarding_flag"] === 0) {
          navigate(_RoutePath.baseRoutes.createProfile.useLink);
        } else if (+userAttr.attributes["custom:onboarding_flag"] === 1) {
          navigate(_RoutePath.baseRoutes.NotificationPreferencesOnboard.useLink);
        } else {
          navigate(_RoutePath.baseRoutes.admin.useLink);
        }
      }).catch(error => {
        console.log("Current User Info Error", error);
      });
      return null;
    }).catch(e => {
      setIsLoading(false);
      navigate('/Login');
    });
    return null;
  });
  (0, _react.useEffect)(() => {
    return () => {};
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", null, isLoading ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    className: "ms-1",
    animation: "border",
    size: "sm"
  }) : null);
}